import merge from 'lodash/merge';

import config from '../../config';
import RestEntityAPI from './restEntityAPI';
import logger from '../logger';
import fetch, { toQueryString } from '../fetch';

const options = {
  entityName: 'hubs',
  endpoint: `${config.apiUrl}/v2/employer/hubs`,
  searchEndpoint: `${config.apiUrl}/v2/employer/hubs`,
};

const HubsAPI = () => {
  const parentAPI = RestEntityAPI(options);

  const getHub = async ({ hubId, ctx }) => {
    const getUrl = `${config.apiUrl}/v2/employer/hubs/${hubId}`;

    try {
      return await fetch(getUrl, {
        method: 'GET',
        ctx: ctx || {},
      });
    } catch (error) {
      logger.logDebug(`Failed to get Hub ${hubId}`, error);
      throw error;
    }
  };

  const getHubs = async (query, profileKey) => {
    const getUrl = `${config.apiUrl}/v2/employer/hubs${toQueryString(query)}`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey, 'X-Check-Roles': true } : {};

    try {
      return await fetch(getUrl, {
        method: 'GET',
        headers,
      });
    } catch (error) {
      logger.logDebug('Failed to search Hubs', error);
      throw error;
    }
  };

  const createHub = async (data) => {
    try {
      const response = await fetch(`${options.endpoint}`, {
        method: 'POST',
        body: data,
      });
      return response;
    } catch (error) {
      logger.logError('Encountered error while creating hub', error);
      throw error;
    }
  };

  const updateHub = async (query, headers) => {
    const { hubId, data } = query;
    const body = { data: { key: hubId, ...data } };
    try {
      return await fetch(`${config.apiUrl}/v2/employer/hubs/${hubId}`, {
        method: 'PATCH',
        body,
        headers,
      });
    } catch (error) {
      logger.logDebug(`Failed to update for ${hubId}`, error);
      throw error;
    }
  };

  const deleteHub = async (hubId) => {
    try {
      return await fetch(`${config.apiUrl}/v2/employer/hubs/${hubId}`, {
        method: 'DELETE',
      });
    } catch (error) {
      logger.logDebug(`Failed to delete for ${hubId}`, error);
      throw error;
    }
  };

  const getHubFeatureElementCount = async ({ hubId, profileKey, ctx }) => {
    const getUrl = `${config.apiUrl}/v2/employer/hubs/${hubId}/feature-element-count`;
    const headers = (profileKey != null) ? {
      'X-Profile-Key': profileKey,
      'X-Check-Roles': true,
    } : {};

    try {
      return await fetch(getUrl, { method: 'GET', headers, ctx: ctx || {} });
    } catch (error) {
      logger.logDebug(`Failed to get Hub ${hubId}`, error);
      throw error;
    }
  };

  return merge({}, { ...parentAPI },
    {
      getHub,
      getHubs,
      createHub,
      updateHub,
      deleteHub,
      getHubFeatureElementCount,
    });
};

export default HubsAPI;
